import { useContext } from 'react';
import NotificationContext from '../context/NotificationContext';

export default () => useContext(NotificationContext);
